<template>
	<div class="banner">
		<div class="limit">
			<div class="img_container1">
				<img class="img1" src="../assets/img/index/黑色背景图1.jpg" alt="中国区独家总代" />
				<div class="title_container">
					<img class="curiosis" src="../assets/img/index/curiosis.png" />
					<div class="chn_banner">
						中国区<span style="color: #FFF100;">独家</span>总代</div>
				</div>
				<div class="eng_title">Exclusive General Agent In China</div>
				<LinkButton class="info" to="/ProductCenter" text="产品信息" variant="dark"></LinkButton>
				<LinkButton class="contact" to="/ContactUs" text="联系我们" variant="yellow"></LinkButton>
			</div>
			<div class="img_container2">
				<img class="img2" src="../assets/img/index/黄色背景图1.jpg" alt="全自动活细胞影像分析系统/自动细胞计数仪" />
				<div class="chn_title">
					<div>※全自动活细胞影像分析系统</div>
					<div style="margin-top: 5px;">※自动细胞计数仪</div>
				</div>
				<div class="eng_title2">
					<div>AUTOMATED LIVE CELL IMAGING SYSTEM</div>
					<div style="margin-top: 2px;">AUTOMATED CELL COUNTER</div>
				</div>
				<LinkButton class="info2" to="/ProductCenter" text="产品信息" variant="dark-ghost"></LinkButton>
				<LinkButton class="contact2" to="/ContactUs" text="联系我们" variant="yellow-dark-border"></LinkButton>
			</div>
			<div class="img_container3">
				<img class="img3" src="../assets/img/index/产品展示.png" alt="产品展示" />
			</div>
		</div>
	</div>
</template>

<script>
	import LinkButton from './public/LinkButton.vue'
	export default {
		name: 'Banner',
		components: {
			LinkButton
		}
	}
</script>

<style scoped>
	.curiosis {
		height: 50px;
		width: 300px;
		margin-top: 10px;
	}

	.img_container1 {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		position: relative;
		margin: 0;
	}

	.img_container2 {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.title_container {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		position: absolute;
		color: #fff;
		margin-bottom: 100px;
	}

	img {
		width: 100%;
		background-size: cover;
	}

	.img1 {
		height: 576px;
	}

	.img2 {
		height: 576px;
	}

	.info {
		margin-left: -360px;
		transform: translate(50%, 350%);
		position: absolute;
		margin-bottom: 100px;
	}

	.contact {
		margin-left: 80px;
		transform: translate(50%, 350%);
		position: absolute;
		margin-bottom: 100px;
	}

	.info2 {
		margin-left: -1000px;
		transform: translate(50%, 350%);
		position: absolute;
	}

	.contact2 {
		margin-left: -560px;
		transform: translate(50%, 350%);
		position: absolute;
	}

	.eng_title {
		transform: translateY(70px);
		position: absolute;
		color: #fff;
		font-size: 20px;
		letter-spacing: 2px;
		font-family: Rany Light;
		margin-bottom: 100px;
	}

	.eng_title2 {
		transform: translate(-65%, 150%);
		position: absolute;
		color: rgb(35, 24, 21);
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 3px;
		font-family: Rany Light;
	}

	.chn_title {
		position: absolute;
		color: #000;
		font-size: 50px;
		transform: translate(-40%, -40%);
		letter-spacing: 1px;
	}

	@keyframes fadeInRight {
		0% {
			opacity: .3;
			transform: translateX(1000px);
		}

		100% {
			opacity: 1;
			transform: translateX(0);
		}
	}
	
	.chn_banner{
		 color: #fff;
		 font-size: 58px;
		 margin-left: 30px;
		 font-weight:bold;
		 letter-spacing: 2px;
	}
	
	@media screen and (max-width: 1150px){
		.img1{
			width: 100%;
			height: auto;
		}
		.title_container{
			margin-bottom: 40px;
		}
		.curiosis{
			width: auto;
			height: 2rem;
		}
		.chn_banner{
			font-size: 2rem;
		}
		.eng_title{
			font-size: 0.8rem;
			margin-bottom: 70px;
		}
		.img2{
			width: 100%;
			height: auto;
		}
		.info{
			display: none;
		}
		.contact{
			display: none;
		}
		.chn_title{
			font-size: 2rem;
		}
		.eng_title2{
			font-size: 0.8rem;
			margin-left: 60px;
		}
		.info2{
			display: none;
		}
		.contact2{
			display: none;
		}
	}
	
	@media screen and (max-width: 800px){
		.img1 {
			height: calc(200px + 10vw);
			width: 100%;
		}
		.img2 {
			height: calc(200px + 10vw);
			width: 100%;
		}
		.curiosis{
			width: auto;
			height: 1.1rem;
			margin-top: 2.2rem;
			margin-left: 10px;
		}
		.chn_banner{
			font-size: 1.1rem;
			margin-top: 2.1rem;
			margin-left: 20px;
		}
		.eng_title{
			font-size: 0.6rem;
			margin-bottom: 5.2rem;
			letter-spacing: 1px;
		}
		
		.chn_title{
			font-size: 1rem;
			margin-left: 50px;
		}
		.eng_title2{
			font-size: 0.5rem;
			margin-left: 5rem;
			letter-spacing: 1px;
		}
		.img_container2{
			animation: none;
		}
	}
	@media screen and (max-width: 280px) {
		.img1 {
			height: calc(200px + 10vw);
			width: 100%;
		}
		.img2 {
			height: calc(200px + 10vw);
			width: 100%;
		}
		.about_img {
			height: calc(200px + 10vw);
			width: 100%;
		}
		.title_container {
			flex-direction: column;
			margin-right: 20px;
		}
		.chn_banner{
			margin-top: 15px;
		}
		.eng_title{
			margin-top: 32px;
		}
	}
</style>